import { useQuery } from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"
import { useMemo } from "react"
import {
  FloorPriceChartMoleculeReatom,
  getChartData,
  getFloorPrice,
  getMaxPrice,
  getMinPrice,
  getPrices,
  getSortedPrices,
  getTrendColorFromPrices,
  hasEnoughDataToShowChart,
} from "./floor-price-chart-molecule.reatom"

export const useFloorPriceChartReatom = () => {
  const molecule = useMolecule(FloorPriceChartMoleculeReatom)
  const queryParams = molecule.floorPriceChangeQueryParams()
  const query = useQuery(queryParams)

  const chartData = useMemo(() => getChartData(query.data), [query.data])

  const prices = useMemo(() => getPrices(query.data), [query.data])

  const hasEnoughData = useMemo(
    () => hasEnoughDataToShowChart(prices),
    [prices],
  )

  const floorPrice = useMemo(() => getFloorPrice(prices), [prices])

  const sortedPrices = useMemo(() => getSortedPrices(prices), [prices])

  const maxPrice = useMemo(() => getMaxPrice(sortedPrices), [sortedPrices])

  const minPrice = useMemo(() => getMinPrice(sortedPrices), [sortedPrices])

  const trendColor = useMemo(() => getTrendColorFromPrices(prices), [prices])

  return {
    // Query state
    isLoading: query.isLoading,
    isError: query.isError,
    data: query.data,

    // Computed values
    chartData,
    prices,
    hasEnoughData,
    floorPrice,
    maxPrice,
    minPrice,
    trendColor,

    // From molecule
    dateFormatter: molecule.dateFormatter(),
    approximateDateLabelWidth: molecule.approximateDateLabelWidth(),
  }
}
